// extracted by mini-css-extract-plugin
export var box = "_56-1";
export var checkboxRow = "_56-8";
export var checked = "_56-2";
export var descriptionSpacer = "_56-a";
export var disabled = "_56-3";
export var icon = "_56-6";
export var input = "_56-0";
export var labelSpacer = "_56-9";
export var medium = "_56-5";
export var small = "_56-4";
export var text = "_56-7";